import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Plane, Sparkles } from "lucide-react";
import { studyAbroad } from "../mock";

export default function StudyAbroadBanner() {
  return (
    <section id="study-abroad" className="section-light py-16 md:py-24 relative overflow-hidden">
      <div className="blob blob-pink w-96 h-96 -top-16 -right-10" />
      <div className="blob blob-cyan w-72 h-72 bottom-0 -left-10" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div
          className="relative rounded-3xl overflow-hidden border border-[#0A1740]/10 shadow-xl"
          style={{
            background:
              "linear-gradient(135deg, #0A1740 0%, #1E1B4B 55%, #3B0764 100%)",
          }}
        >
          {/* Cherry blossom decorative image */}
          <div className="absolute inset-0 opacity-30 mix-blend-screen">
            <img
              src={studyAbroad.hero}
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A1740]/85 via-[#1E1B4B]/70 to-transparent" />

          <div className="relative grid lg:grid-cols-2 gap-8 items-center p-8 md:p-14">
            <div className="text-white">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-amber-300 text-xs font-black tracking-wider uppercase backdrop-blur">
                <Sparkles size={14} /> New – Global Program
              </div>
              <h2 className="section-title mt-4 text-4xl md:text-6xl font-black leading-[0.95]">
                Study in{' '}
                <span
                  className="text-amber-300"
                  style={{ fontFamily: "Caveat, cursive", fontWeight: 700 }}
                >
                  South Korea
                </span>
              </h2>
              <p className="mt-3 text-white/85 max-w-lg text-base md:text-lg">
                Shape your future with a global education at{' '}
                <span className="font-bold text-amber-300">Gimcheon University</span>. Admissions now
                open through CYA – your authorized partner in Vizianagaram.
              </p>

              <div className="mt-5 inline-flex items-center gap-2 text-white/80 text-sm">
                <MapPin size={16} className="text-amber-300" />
                <span>Gimcheon, Gyeongsangbuk-do, South Korea</span>
              </div>

              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to="/study-in-korea"
                  className="btn-primary px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm md:text-base"
                >
                  Explore Program <ArrowRight size={18} />
                </Link>
                <a
                  href="tel:+918249622167"
                  className="px-6 py-3.5 rounded-full inline-flex items-center gap-2 text-sm md:text-base border border-white/25 text-white hover:bg-white/10 transition-colors backdrop-blur"
                >
                  <Plane size={18} /> Call for Free Counselling
                </a>
              </div>
            </div>

            <div className="relative hidden lg:block">
              <div className="relative rounded-3xl overflow-hidden border-4 border-white/20 aspect-[4/3] shadow-2xl">
                <img
                  src={studyAbroad.campus}
                  alt="Gimcheon University campus in South Korea"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-amber-400 text-[#0A1740] rounded-2xl px-4 py-3 shadow-xl floaty2">
                <div className="text-[10px] uppercase tracking-widest font-black">Est. 1978</div>
                <div className="text-sm font-extrabold">김천대학교</div>
              </div>
              <div className="absolute -top-3 -right-3 bg-white text-[#0A1740] rounded-2xl px-4 py-3 shadow-xl floaty">
                <div className="text-[10px] uppercase tracking-widest font-black text-[#EC4899]">Scholarships</div>
                <div className="text-sm font-extrabold">Merit-based</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
